// extracted by mini-css-extract-plugin
export default {"articleTitle":"certificateFlow_articleTitle__QOnXz","pictureContainer":"certificateFlow_pictureContainer__BbtZi"};